import { gql } from 'apollo-client-ppc';

export const checkAppCompatibilityWithParentProductQuery = gql`
  query checkAppCompatibilityWithParentProduct($parentProductKey: String, $appProductKey: String) {
    isAppCompatibleWithParentProduct(parentProductKey: $parentProductKey, appProductKey: $appProductKey) {
      isAppCompatibleWithProduct
    }
  }
`;
